// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1snaL","legacyBtn":"MutateMid_legacyBtn__3Ayzz"};